import { useLocalStorage } from 'usehooks-ts';
import { useState } from 'react';
import useListenFromRn from '../utilities/useListenFromRn';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '../utilities/use-mobile';
import { useSession } from '@/contexts/LitSessionProvider';

//trigger cooldown 3 weeks
const COOLDOWN = 1000 * 60 * 60 * 24 * 21;
export default function useTriggerInAppReview() {
  const {
    PKP
  } = useSession();
  const [lastAsked, setLastAsked] = useLocalStorage(`lastAskedReview-${PKP?.ethAddress}`, null);
  const [openModal, setOpenModal] = useState(false);
  const {
    sendMessageToRN
  } = useListenFromRn();
  const isMobile = useIsMobile();
  function startReviewFlow() {
    if (lastAsked && Date.now() - lastAsked < COOLDOWN || !isMobile) {
      return;
    }
    setOpenModal(true);
    setLastAsked(Date.now());
  }
  function triggerInAppReview() {
    sendMessageToRN({
      action: 'ACTION_TRIGGER_IN_APP_REVIEW',
      payload: {}
    });
    const oneYearInTheFuture = new Date();
    oneYearInTheFuture.setFullYear(oneYearInTheFuture.getFullYear() + 1);
    setLastAsked(oneYearInTheFuture.getTime());
  }
  const ReviewModal = () => {
    return <SlidingModal isOpen={openModal} onClose={() => {
      setOpenModal(false);
      setLastAsked(Date.now());
    }} heightFit={true} data-sentry-element="SlidingModal" data-sentry-component="ReviewModal" data-sentry-source-file="useTriggerInAppReview.tsx">
        <div className='p-4'>
          <div className='flex  items-end justify-between'>
            <div className='text-[16px] font-bold text-genius-cream'>Enjoying Genius?</div>
            <ImageWithFallback src='/static/icons/genius-purple.png' alt='Genius Logo' className='rounded-md' width={50} height={50} data-sentry-element="ImageWithFallback" data-sentry-source-file="useTriggerInAppReview.tsx" />
          </div>
          <div className='text-[16px] text-genius-cream/50 mt-4'>
            If you are enjoying Genius, please take a moment to rate us on the App Store.Thanks for
            your support!
          </div>
          <div className='flex gap-2 mt-8'>
            <Button className='w-1/2' variant='pink' onClick={triggerInAppReview} data-sentry-element="Button" data-sentry-source-file="useTriggerInAppReview.tsx">
              Leave a Review
            </Button>
            {/* close */}
            <Button className='w-1/2' variant='blue' onClick={() => {
            setOpenModal(false);
            setLastAsked(Date.now());
          }} data-sentry-element="Button" data-sentry-source-file="useTriggerInAppReview.tsx">
              No Thanks
            </Button>
          </div>
        </div>
      </SlidingModal>;
  };
  return {
    startReviewFlow,
    ReviewModal
  };
}